import { Guest, PartialBrief, PasswordlessGuest } from '../../Types/Brief'

const STORAGE_KEY = 'hb-brief'

interface StoredBrief extends Omit<PartialBrief, 'guest'> {
  guest?: PasswordlessGuest
}

export const getStoredBrief = (): PartialBrief => {
  const storedStr = localStorage.getItem(STORAGE_KEY)
  if (!storedStr) return {}

  const storedBrief = JSON.parse(storedStr) as StoredBrief
  const { guest: storedGuest } = storedBrief

  return {
    ...storedBrief,
    ...(storedGuest ? { guest: { ...storedGuest, password: undefined } } : { guest: undefined }),
  }
}

const filterPassword = (guest?: Guest): PasswordlessGuest =>
  guest ? { ...guest, password: null } : { password: null }

export const setStoredBrief = (brief: PartialBrief): void => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...brief, guest: filterPassword(brief.guest) })
  )
}

export const removeStoredBrief = (): void => {
  localStorage.removeItem(STORAGE_KEY)
}
